import { ReactComponent as IcStats } from '@assets/components/panel/reporting/ic-stats.svg';
import { Box, Icon, Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

type Props = {
  title: string;
  children: ReactNode;
  width: string;
  isEmpty: boolean;
  emptyLabel?: string;
};

export default function ChartWrapper({ title, children, width, isEmpty, emptyLabel }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  return (
    <Box width={width} height="100%" backgroundColor="neutral.800" padding={3} flexShrink={0}>
      <VStack height="100%" width="100%" gap={3} flex={1} alignItems="start">
        <Text textTransform="uppercase" fontWeight="medium">
          {title}
        </Text>
        {isEmpty ? (
          <VStack boxSize="100%" gap={2} justifyContent="center">
            <Icon as={IcStats} boxSize="48px" color="neutral.600" />
            <Text>{emptyLabel ?? formatMessage({ id: 'global.noData' })}</Text>
          </VStack>
        ) : (
          children
        )}
      </VStack>
    </Box>
  );
}
